/**
 * Messaging Types
 *
 * The wire shapes actually produced by apps/backend/src/controllers/MessageController.ts
 * (toWireMessage/toWireConversation) — single source of truth for both the
 * backend response and the frontend's MessageApiService, replacing two
 * independently hand-maintained copies that had drifted (a `content: string`
 * that's really nullable, a `readAt` field the backend never sends).
 */
/** "Until I unmute": stored as a far-future mute end. */
export const MUTE_FOREVER_ISO = '9999-12-31T00:00:00.000Z';
/** Photos and documents: 10 MB. Videos: 25 MB. */
export const CHAT_MEDIA_LIMITS = {
    imageBytes: 10 * 1024 * 1024,
    videoBytes: 25 * 1024 * 1024,
    documentBytes: 10 * 1024 * 1024,
};
/** Editing your own message is allowed this long after sending. */
export const MESSAGE_EDIT_WINDOW_MS = 15 * 60000;
/** "Delete for everyone" is allowed this long after sending. */
export const MESSAGE_DELETE_FOR_EVERYONE_WINDOW_MS = 60 * 60000;
/** Pinned messages per conversation. */
export const MAX_PINNED_MESSAGES = 3;
/** Conversations one message can be forwarded to at once. */
export const MAX_FORWARD_TARGETS = 5;
